import type { PricingRules } from './catalog'

const currencyNoise = /[^0-9.,'’\-]/g

export function parseMoneyToCents(input: unknown): number | null {
  if (typeof input === 'number') {
    return Number.isFinite(input) ? Math.round(input * 100) : null
  }

  if (typeof input !== 'string') return null
  let value = input.trim().replace(currencyNoise, '').replace(/['’]/g, '')
  if (!value || !/\d/.test(value)) return null

  const minusCount = value.match(/-/g)?.length ?? 0
  if (minusCount > 1 || (minusCount === 1 && !value.startsWith('-'))) return null

  const negative = value.startsWith('-')
  if (negative) value = value.slice(1)

  const comma = value.lastIndexOf(',')
  const dot = value.lastIndexOf('.')
  let decimalSeparator = ''

  if (comma >= 0 && dot >= 0) {
    decimalSeparator = comma > dot ? ',' : '.'
  } else if (comma >= 0) {
    const decimals = value.length - comma - 1
    decimalSeparator = decimals > 0 && decimals <= 2 ? ',' : ''
  } else if (dot >= 0) {
    const decimals = value.length - dot - 1
    decimalSeparator = decimals > 0 && decimals <= 2 ? '.' : ''
  }

  if (decimalSeparator) {
    const parts = value.split(decimalSeparator)
    const decimal = parts.pop() ?? ''
    value = `${parts.join('').replace(/[.,]/g, '')}.${decimal}`
  } else {
    value = value.replace(/[.,]/g, '')
  }

  const parsed = Number(value)
  if (!Number.isFinite(parsed)) return null
  return Math.round((negative ? -parsed : parsed) * 100)
}

export function calculateRegularPrice(costCents: number, rules: PricingRules): number {
  const withMarkup = costCents * (1 + rules.markupPercent / 100)
  const withTax = withMarkup * (1 + rules.taxPercent / 100)
  return Math.round(withTax / rules.roundingIncrement) * rules.roundingIncrement
}

export function formatMoney(cents: number | null): string {
  if (cents === null) return '—'
  return (cents / 100).toFixed(2)
}
